import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";

export const fetchHistories = createAsyncThunk(
  "history/fetchHistories",
  async (courseIds, { rejectWithValue }) => {
    try {
      const ids = Array.isArray(courseIds) ? courseIds : courseIds ? [courseIds] : [];
      const params = new URLSearchParams();
      ids.forEach((id) => params.append("courseId", id));
      const query = params.toString();
      const url = query
        ? `/student/getExamHistory?${query}`
        : "/student/getExamHistory";
      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const historySlice = createSlice({
  name: "history",
  initialState: {
    history: [],
    // Tracks the most recently dispatched request, so a slower/older
    // request (e.g. for a course the user already switched away from)
    // can't overwrite a newer one that resolved first.
    currentRequestId: undefined,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistories.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchHistories.fulfilled, (state, action) => {
                if (action.meta.requestId !== state.currentRequestId) return;
                state.loading = false;
                state.history = action.payload;
              })
      .addCase(fetchHistories.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.error = action.payload || "Failed to fetch dashboard data";
      });
  },
});

export default historySlice.reducer;